import { css } from "@emotion/react";

export const tableStyle = css`
  overflow: auto;
`;

export const iconStyle = css`
  height: 18px;
  margin-right: 20px;
`;

export const waitingIconStyle = css`
  width: 44px;
  height: 22px;
`;
